import { createBrowserRouter } from "react-router-dom";

import Login from "./screens/login.screen";
import CustomersScreen from "./screens/customers.screen";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Login />,
  },
  {
    path: "/customers",
    element: <CustomersScreen />,
  },
]);


export default router;